<template>
<div class="collapse-box" ref="collapseBox">
  <slot></slot>
</div>
</template>

<script>
export default {
  name: '',
  components: {},
  provide() {
    return {
      minHeight: this.minHeight,
      getExpand: this.getExpand,
      setExpand: this.setExpand,
      getHideExpandBtn: this.getHideExpandBtn,
    };
  },
  props: {
    minHeight: {
      type: Number,
      default: 0,
    },
    defaultExpand: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expand: this.defaultExpand, // 是否展开
      hideExpandBtn: true,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$nextTick(() => {
        const contetnEl = this.$el.querySelector('.collapse-transition-box');

        if (this.minHeight && contetnEl && contetnEl.scrollHeight <= this.minHeight) {
          // 小于最小高度，隐藏展开按钮
          this.hideExpandBtn = true;
        } else {
          this.hideExpandBtn = false;
        }
      });
    },
    getExpand() {
      return this.expand;
    },
    setExpand(value) {
      this.expand = value;
    },
    getHideExpandBtn() {
      return this.hideExpandBtn;
    },

  },
};
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/components/common/collapse/collapse-box.vue